import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Bali (1-96)
import bali1 from '../images/bali1.jpeg';
import bali2 from '../images/bali2.jpeg';
import bali3 from '../images/bali3.jpeg';
import bali4 from '../images/bali4.jpeg';
import bali5 from '../images/bali5.jpeg';
import bali6 from '../images/bali6.jpeg';
import bali7 from '../images/bali7.jpeg';
import bali8 from '../images/bali8.jpeg';
import bali9 from '../images/bali9.jpeg';
import bali10 from '../images/bali10.jpeg';
import bali11 from '../images/bali11.jpeg';
import bali12 from '../images/bali12.jpeg';
import bali13 from '../images/bali13.jpeg';
import bali14 from '../images/bali14.jpeg';
import bali15 from '../images/bali15.jpeg';
import bali16 from '../images/bali16.jpeg';
import bali17 from '../images/bali17.jpeg';
import bali18 from '../images/bali18.jpeg';
import bali19 from '../images/bali19.jpeg';
import bali20 from '../images/bali20.jpeg';
import bali21 from '../images/bali21.jpeg';
import bali22 from '../images/bali22.jpeg';
import bali23 from '../images/bali23.jpeg';
import bali24 from '../images/bali24.jpeg';
import bali25 from '../images/bali25.jpeg';
import bali26 from '../images/bali26.jpeg';
import bali27 from '../images/bali27.jpeg';
import bali28 from '../images/bali28.jpeg';
import bali29 from '../images/bali29.jpeg';
import bali30 from '../images/bali30.jpeg';
import bali31 from '../images/bali31.jpeg';
import bali32 from '../images/bali32.jpeg';
import bali33 from '../images/bali33.jpeg';
import bali34 from '../images/bali34.jpeg';
import bali35 from '../images/bali35.jpeg';
import bali36 from '../images/bali36.jpeg';
import bali37 from '../images/bali37.jpeg';
import bali38 from '../images/bali38.jpeg';
import bali39 from '../images/bali39.jpeg';
import bali40 from '../images/bali40.jpeg';
import bali41 from '../images/bali41.jpeg';
import bali42 from '../images/bali42.jpeg';
import bali43 from '../images/bali43.jpeg';
import bali44 from '../images/bali44.jpeg';
import bali45 from '../images/bali45.jpeg';
import bali46 from '../images/bali46.jpeg';
import bali47 from '../images/bali47.jpeg';
import bali48 from '../images/bali48.jpeg';
import bali49 from '../images/bali49.jpeg';
import bali50 from '../images/bali50.jpeg';
import bali51 from '../images/bali51.jpeg';
import bali52 from '../images/bali52.jpeg';
import bali53 from '../images/bali53.jpeg';
import bali54 from '../images/bali54.jpeg';
import bali55 from '../images/bali55.jpeg';
import bali56 from '../images/bali56.jpeg';
import bali57 from '../images/bali57.jpeg';
import bali58 from '../images/bali58.jpeg';
import bali59 from '../images/bali59.jpeg';
import bali60 from '../images/bali60.jpeg';
import bali61 from '../images/bali61.jpeg';
import bali62 from '../images/bali62.jpeg';
import bali63 from '../images/bali63.jpeg';
import bali64 from '../images/bali64.jpeg';
import bali65 from '../images/bali65.jpeg';
import bali66 from '../images/bali66.jpeg';
import bali67 from '../images/bali67.jpeg';
import bali68 from '../images/bali68.jpeg';
import bali69 from '../images/bali69.jpeg';
import bali70 from '../images/bali70.jpeg';
import bali71 from '../images/bali71.jpeg';
import bali72 from '../images/bali72.jpeg';
import bali73 from '../images/bali73.jpeg';
import bali74 from '../images/bali74.jpeg';
import bali75 from '../images/bali75.jpeg';
import bali76 from '../images/bali76.jpeg';
import bali77 from '../images/bali77.jpeg';
import bali78 from '../images/bali78.jpeg';
import bali79 from '../images/bali79.jpeg';
import bali80 from '../images/bali80.jpeg';
import bali81 from '../images/bali81.jpeg';
import bali82 from '../images/bali82.jpeg';
import bali83 from '../images/bali83.jpeg';
import bali84 from '../images/bali84.jpeg';
import bali85 from '../images/bali85.jpeg';
import bali86 from '../images/bali86.jpeg';
import bali87 from '../images/bali87.jpeg';
import bali88 from '../images/bali88.jpeg';
import bali89 from '../images/bali89.jpeg';
import bali90 from '../images/bali90.jpeg';
import bali91 from '../images/bali91.jpeg';
import bali92 from '../images/bali92.jpeg';
import bali93 from '../images/bali93.jpeg';
import bali94 from '../images/bali94.jpeg';
import bali95 from '../images/bali95.jpeg';
import bali96 from '../images/bali96.jpeg';

function Bali() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    bali1, bali2, bali3, bali4, bali5, bali6, bali7, bali8, bali9, bali10,
    bali11, bali12, bali13, bali14, bali15, bali16, bali17, bali18, bali19, bali20,
    bali21, bali22, bali23, bali24, bali25, bali26, bali27, bali28, bali29, bali30,
    bali31, bali32, bali33, bali34, bali35, bali36, bali37, bali38, bali39, bali40,
    bali41, bali42, bali43, bali44, bali45, bali46, bali47, bali48, bali49, bali50,
    bali51, bali52, bali53, bali54, bali55, bali56, bali57, bali58, bali59, bali60,
    bali61, bali62, bali63, bali64, bali65, bali66, bali67, bali68, bali69, bali70,
    bali71, bali72, bali73, bali74, bali75, bali76, bali77, bali78, bali79, bali80,
    bali81, bali82, bali83, bali84, bali85, bali86, bali87, bali88, bali89, bali90,
    bali91, bali92, bali93, bali94, bali95, bali96
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>Bali 2020</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Bali ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Bali;